import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

// components
import {
  BlackWhiteRoundedButton,
  ExportLinkCSV,
  MainLayout,
} from "components/index";

// containers
import { FilteredList } from "containers";

// utils
import translations from "utils/translations";

import { filtersList } from "./PressList.filters";
import useHeader from "./PressList.header";
import { useRegistryDataListFetch } from "hooks";
import { HeaderContainer } from "./PressList.styles";

import { REGISTRY_PRESS_CREATE } from "constants/routes";

function PressList() {
  const [header] = useHeader();
  const intl = useIntl();
  const i18n = translations.components.RegistryLists(intl);
  const navigate = useNavigate();

  const renderHeaderAction = () => {
    return (
      <>
        <HeaderContainer>
          <BlackWhiteRoundedButton
            onClick={() => navigate(REGISTRY_PRESS_CREATE)}
            label={i18n.employees.createbtnText}
          />
          <ExportLinkCSV />
        </HeaderContainer>
      </>
    );
  };
  return (
    <MainLayout>
      <FilteredList
        useCustomFetch={useRegistryDataListFetch}
        i18n={i18n.press}
        i18nErrors={i18n.errors}
        header={header}
        headerAction={renderHeaderAction()}
        filtersList={filtersList}
        queryUserTypeParams={"&Group=PRESS&"}
      />
    </MainLayout>
  );
}

export { PressList };
